import React from "react";

import { CTABlock as EcomCTABlock } from "@lululemon/ecom-pattern-library-cta-block";

import styles from "./cta-block.module.scss";

/**
 * CTA block for digital educator content
 *
 * @param {Object} props - The component props.
 * @param {('desktop'|'mobile')} [props.variant="desktop"] - The variant of the component.
 * @param {Function} props.handleClick - The click handler function.
 *
 * @returns {React.ReactElement} - &lt;CTABlock variant="mobile" /&gt; The rendered component
 */
export default function CTABlock({ variant, handleClick }) {
  return (
    <EcomCTABlock
      href="https://www.lululemon-virtualshopping.com/"
      subContent="Virtual shop with one of our educators"
      data-lulu-track="pdp-digital-educator-cta-1"
      data-testid="cta-block"
      className={`${styles.root} ${variant === "mobile" ? styles.mobile : ""}`}
      heading={
        <span className={styles.heading}>
          Questions?
          {variant === "mobile" ? <br /> : " "}
          Bring them on (all of them)
        </span>
      }
      onClick={handleClick}
      rel="nofollow"
    />
  );
}

EcomCTABlock.displayName = "CTABlock";
